import React, { useEffect, useState } from 'react';
import { AddIcon, EditLargeIcon, LoadingIcon } from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import Switch from "../form/Switch";
import FormHeader from "../form/Header";
import Popup from "../Popup";
import { CreateOffice } from "../../api/offices/CreateOffice";
import { useUserContext } from '../../contexts/UserContext';
import StateSelect from "../form/StateSelect";
import CountrySelect from "../form/CountrySelect";
import useForm from "../../hooks/useForm";
import {useTranslation} from "react-i18next";

const CreateOfficeForm = ({ onCreate, onClose, ...props }) => {
    const { t } = useTranslation();
    const [status, setStatus] = useState(false);
    const [name, setName] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [country, setCountry] = useState('');
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const { userData } = useUserContext();
    const company_id = userData.company_id;

    const { loading, error, fieldErrors, handleSubmit } = useForm(onCreate);

    useEffect(() => {
        if (name && address1 && city && state && postalCode && country) {
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [status, name, address1, city, state, postalCode, country]);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        handleSubmit(CreateOffice, { company_id, name, status, address1, address2, postalCode, state, city, country });
    };

    return (
        <Popup size="large" withClose withOverlay onClose={onClose}>
            <form method="post" onSubmit={handleFormSubmit}>
                <FormHeader title={t("Create")} description={t("Create your office here.")}
                            icon={<EditLargeIcon />}></FormHeader>

                <div className="row mb-5 mt-5 align-items-center">
                    <div className="col-xs-6">
                        <Switch title={t("Active")}>
                            <input type="checkbox" name="status" id="status" onChange={e => { setStatus(e.target.checked) }} />
                        </Switch>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-12">
                        <FormSection title={t("Office Name")} required>
                            <input type="text" name="name" id="name" maxLength="50" value={name}
                                   placeholder={t("Office Name")}
                                   onChange={e => setName(e.target.value)} />
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Address 1")} required>
                            <input type="text" name="address1" id="address1" maxLength="50" value={address1}
                                   placeholder={t("Input address 1")}
                                   onChange={e => setAddress1(e.target.value)} />
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Address 2 (Optional)")}>
                            <input type="text" name="address2" id="address2" maxLength="50" value={address2}
                                   placeholder={t("Input address 2")}
                                   onChange={e => setAddress2(e.target.value)} />
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("City")} required>
                            <input type="text" name="city" id="city" maxLength="50" value={city}
                                   placeholder={t("City")}
                                   onChange={e => setCity(e.target.value)} />
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Province")} required>
                            <StateSelect value={state} onChange={option => setState(option.value)} />
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Postal Code")} required>
                            <input type="text" name="postalCode" id="postalCode" maxLength="50" value={postalCode}
                                   placeholder={t("Postal Code")}
                                   onChange={e => setPostalCode(e.target.value)} />
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Country")} required>
                            <CountrySelect onlyCountry={'Canada'} value={country} onChange={option => setCountry(option.value)} />
                        </FormSection>
                    </div>
                </div>

                <div className="text-right">
                    <button className={`btn btn-primary btn-medium ${loading ? 'btn-loading' : ''}`} type="submit"
                            name="submit" disabled={submitDisabled}>
                        {loading ? <LoadingIcon /> : <AddIcon />}
                        {t("Add")}
                    </button>
                </div>
                {error && <p className="color-error text-center mt-3">{error}</p>}
                {fieldErrors.map((error, index) => (
                    <p key={index} className="color-error text-center mt-3">{error.message}</p>
                ))}
            </form>
        </Popup>
    );
};

export default CreateOfficeForm;
